export default "__VITE_ASSET__BRX8I1n1__"